module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"viewTransactions":"View transactions","payout":"Pay out","extraIncome":"Extra income"},"et":{"viewTransactions":"View transactions","payout":"Pay out","extraIncome":"Extra income"},"ru":{"viewTransactions":"View transactions","payout":"Pay out","extraIncome":"Extra income"}}')
  delete Component.options._Ctor
}
